<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <b-field label="示意圖(各館次首頁產品選單下方廣告)">
          <p class="control">
            <a
              :href="helpImageUrl('各館次首頁產品選單下方廣告.png')"
              @click.prevent="
                onClickImage(helpImageUrl('各館次首頁產品選單下方廣告.png'))
              "
            >
              <img
                :src="helpImageUrl('各館次首頁產品選單下方廣告.png')"
                alt="各館次首頁產品選單下方廣告"
                width="64"
              />
            </a>
          </p>
        </b-field>

        <hr />

        <editor
          ref="bottom_ad_editor"
          v-model="form.bottom_ad"
          :area="catalog.image_path"
        ></editor>

        <b-field>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            :style="{ width: '100%' }"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { CATALOG_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import Editor from '@/components/editors/Editor4'
import { maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'BottomAdForm',
  components: { Editor },

  props: {
    catalog: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,

      form: this.extractFormValues(this.catalog),

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      bottom_ad: { maxLength: maxLength(50000) }
    }
  },
  watch: {
    catalog(newCatalog) {
      this.form = this.extractFormValues(newCatalog)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        bottom_ad: data.bottom_ad || ''
      }
    },
    async onSend() {
      this.form.bottom_ad = this.$refs.bottom_ad_editor.getData()

      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${CATALOG_API}/${this.catalog.catalog_no}/bottom-ad`

      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)

        this.$emit('updated', res.data.data)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    }
  }
}
</script>
